import Price from './Price/Price.vue'
import FormatService from '../../../services/format-service'
import {mapState} from 'vuex'

export default {
    name: 'Product',
    props: {
        product: {}
    },
    components: {
        Price
    },
    data() {
        return {
            
        }
    },
    methods: {
        add(product){
            const el = document.getElementById(product.id.toString())
            this.$store.dispatch('cart/updateOrAddCart', {product: product, quantity: el.valueAsNumber});
        },
        setImageNotFound(event) {
            event.target.src = "/img/no-image-available.png"
        }
    },
    computed: {
        ...mapState({
            user: state => state.account.user
        }),
    },
    filters: {
        euro(value) {
            return FormatService.euro(value)
        }
    }
}